export default __webpack_public_path__ + "./images/mk.5ea9383d.png";